import { useSelector } from 'react-redux';
import { selectMonthsInRange } from '../store/selectors';

export function useMonthlyMonths() {
  return useSelector(selectMonthsInRange);
}
